import React from "react";

import {ReactComponent as FilledRadioCircle} from 'assets/img/filledRadioCircle.svg';
import {ReactComponent as EmptyRadioCircle} from 'assets/img/emptyRadioCircle.svg';
import LazyImage from 'gui/components/LazyImage/LazyImage';

export interface IRadioCirclePngProps {
  state?: boolean;
  onClick?: (state: boolean) => void;
  radioSelectedPath?: string;
  radioNotSelectedPath?: string;
  labelTrue?: string;
  labelFalse?: string;
}

const RadioCirclePng = (props: IRadioCirclePngProps) => {
  return <LazyImage
    src={props.state === true ? props.radioSelectedPath : props.radioNotSelectedPath}
    title={props.state ? props.labelTrue : props.labelFalse}
  />;
};

RadioCirclePng.defaultProps = {
  state: false,
  onClick: (state: boolean) => {
  },
  radioSelectedIcon: FilledRadioCircle,
  radioNotSelectedIcon: EmptyRadioCircle,
  labelTrue: 'Yes',
  labelFalse: 'No',
};
export default RadioCirclePng;
